// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"179":"f56ce6f3","396":"b4d48ff7","540":"9d47a898","640":"7110d991","672":"f11e956b","804":"f2ea84c9"}[chunkId] + ".css";
};